import { FC } from 'react'

import { Button, Stack, useTheme } from '@mui/material'

import { CONTROLS_HEIGHT } from './FiltersDrawer'

type Props = {
  onClose: () => void
  onSubmit: () => void
  submitDisabled?: boolean
}

export const FiltersDrawerBottomControls: FC<Props> = ({ onClose, onSubmit, submitDisabled }) => {
  const theme = useTheme()

  return (
    <Stack
      direction="row"
      justifyContent="flex-end"
      gap={1}
      px={2}
      py={1}
      sx={{
        height: CONTROLS_HEIGHT,
        backgroundColor: theme.palette.background.paper,
        borderTop: (theme) => `1px solid ${theme.palette.divider}`
      }}
    >
      <Button variant="outlined" sx={{ flex: 1 }} color="primary" onClick={onClose}>
        Cancel
      </Button>
      <Button
        variant="contained"
        sx={{ flex: 1 }}
        color="primary"
        onClick={onSubmit}
        disabled={submitDisabled}
      >
        Apply
      </Button>
    </Stack>
  )
}
